import { FC } from 'react'
import { KeyValuePairs } from '@aws-northstar/ui'
import {
    Box,
    Container,
    Header,
    SpaceBetween
} from '@cloudscape-design/components'
 
import type { ProjectApproval } from '../../../types/projects'
 
interface ApprovalDetailsProps {
    approvalDetails: ProjectApproval
}
 
const resolveVpcAliasesFromApproval = (
	details: Record<string, unknown> | undefined
): { identifier: string; value: string } => {
	if (!details) return { identifier: 'tag:Name', value: '-' }
	const nested = details.VpcAliases ?? details.vpcAliases
	const fromNested =
		nested && typeof nested === 'object'
			? {
					identifier: String(
						(nested as { identifier?: unknown }).identifier ?? ''
					).trim(),
					value: String((nested as { value?: unknown }).value ?? '').trim()
			  }
			: { identifier: '', value: '' }
	return {
		identifier:
			String(details.vpcIdentifier ?? fromNested.identifier ?? 'tag:Name').trim() ||
			'tag:Name',
		value: String(details.vpcValue ?? fromNested.value ?? '').trim() || '-'
	}
}

const EphemeralApprovalDetails: FC<ApprovalDetailsProps> = ({ approvalDetails }) => {
    const approvalDetailsKeyValuePairsItems = [
        [{ label: 'Approver', value: approvalDetails?.approverID }],
        [{ label: 'Approved Date', value: approvalDetails?.timestamp }]
    ]
 
    const platformNametags = [
        [{ label: 'Platform Name', value: approvalDetails?.details?.platformName }]
    ]
 
    const vpcAliases = resolveVpcAliasesFromApproval(
        approvalDetails?.details as Record<string, unknown> | undefined
    )

    const generalDetailsKeyValuePairsItems = [
        [{ label: 'DNS Zone Apex', value: approvalDetails?.details?.dnsZoneApex }],
        [{ label: 'VPC Identifier', value: vpcAliases.identifier }],
        [{ label: 'VPC Value', value: vpcAliases.value }]
    ]
 
    return (
        <Container header={<Header variant="h3">Approval Details</Header>}>
            <SpaceBetween direction="vertical" size="l">
                <KeyValuePairs
                    key={'approvalDetails'}
                    items={approvalDetailsKeyValuePairsItems}
                />
                {/* <Box variant="h5">
                    <KeyValuePairs key={'Platform Name'} items={platformNametags} />
                </Box> */}

            </SpaceBetween>
        </Container>
    )
}
 
export default EphemeralApprovalDetails